import { call, put, all, takeEvery } from "redux-saga/effects";
import { FETCH_CATEGORY_GAME_COUNT } from "./actionTypes"
import { fetchCategoryGameCountSuccess } from "./actions";
import { makeAjax, url, showMessage } from "../../helpers/global_helper";
import { USER_MS_EXT } from "../../helpers/url_helper";

function* fetchCategoryGameCount() {
    try {

        const response = yield call(
            makeAjax,
            url.USER_API.getCategorywiseGameCount,
            {},
            USER_MS_EXT
        );
        if (response.status == 'SUCCESS') {
            yield all([
                put(fetchCategoryGameCountSuccess({ response: response.data }))
            ]);
        }
        else {
            showMessage(response);
        }
    } catch (error) {
        showMessage(error);

        // alert
    }
}

function* categoryGameCountSaga() {
    yield takeEvery(FETCH_CATEGORY_GAME_COUNT, fetchCategoryGameCount);
}

export default categoryGameCountSaga;
